import { Static, Type } from '@sinclair/typebox';

// Contrat de l'API du service de scraping (packages/scraper, déployé sur VPS).
// Partagé entre le scraper et le backend (WebsitePreviewExtractorService, Lot B2).

// 'page' : rend une seule URL (page plateforme type Planity/Treatwell).
// 'crawl' : crawl multi-pages d'un site complet (Wix, WordPress, générique).
export const WebsiteScrapeModeSchema = Type.Union([Type.Literal('page'), Type.Literal('crawl')]);
export type WebsiteScrapeMode = Static<typeof WebsiteScrapeModeSchema>;

export const WebsiteScrapeRequestSchema = Type.Object({
  url: Type.String({ format: 'uri' }),
  mode: WebsiteScrapeModeSchema,
  // Plafond de pages en mode 'crawl' (ignoré en mode 'page').
  max_pages: Type.Optional(Type.Integer({ minimum: 1, maximum: 30 })),
});
export type WebsiteScrapeRequestObject = Static<typeof WebsiteScrapeRequestSchema>;

// Image scrapée avec son contexte sémantique pour le matching photo↔prestation.
// `alt` : attribut alt natif (rarement présent mais très fiable quand renseigné).
// `context` : figcaption / aria-label / heading le plus proche dans le DOM, sinon og:title.
export const ScrapedImageSchema = Type.Object({
  url: Type.String(),
  alt: Type.Optional(Type.String()),
  context: Type.Optional(Type.String()),
});
export type ScrapedImageObject = Static<typeof ScrapedImageSchema>;

export const ScrapedPageSchema = Type.Object({
  url: Type.String(),
  title: Type.Optional(Type.String()),
  html: Type.String(),
  text: Type.String(),
  is_entry: Type.Boolean(),
  // URLs absolues des images de la page (img, srcset, og:image), dédupliquées,
  // enrichies du contexte sémantique pour le matching photo↔contenu.
  images: Type.Array(ScrapedImageSchema),
});
export type ScrapedPageObject = Static<typeof ScrapedPageSchema>;

export const WebsiteScrapeResultSchema = Type.Object({
  source_url: Type.String(),
  mode: WebsiteScrapeModeSchema,
  page_count: Type.Integer(),
  duration_ms: Type.Integer(),
  pages: Type.Array(ScrapedPageSchema),
});
export type WebsiteScrapeResultObject = Static<typeof WebsiteScrapeResultSchema>;
